import { render, staticRenderFns } from "./qkPage.vue?vue&type=template&id=e50907e0&scoped=true"
import script from "./qkPage.vue?vue&type=script&lang=js"
export * from "./qkPage.vue?vue&type=script&lang=js"
import style0 from "./qkPage.vue?vue&type=style&index=0&id=e50907e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50907e0",
  null
  
)

export default component.exports